/* eslint-disable import/no-commonjs */
if (typeof window === 'undefined' || process.env.NODE_ENV === 'test') {
  module.exports = require('./serverConfig');
} else {
  module.exports = require('./clientConfig');
}
